import { MarketingConfig } from '@/types'

export const marketingConfig: MarketingConfig = {
  // Links plus one call to action (Book a demo, in the header). For parents and For schools 404 for
  // signed-out visitors, so they're gone.
  mainNav: [
    {
      title: 'Features',
      href: '/features',
      featureFlags: ['features_page']
    },
    {
      title: 'How it works',
      href: '/how-it-works'
    },
    {
      title: 'Pricing',
      href: '/pricing',
      featureFlags: ['pricing_page']
    },
    {
      title: 'Blog',
      href: '/blog'
    },
    {
      title: 'About',
      href: '/about'
    },
    {
      title: 'Get started',
      href: '/start',
      featureFlags: ['start_page']
    }
    // {
    //   title: 'Documentation',
    //   href: '/docs',
    //   disabled: true,
    // },
    // {
    //   title: 'Contact Us',
    //   href: '/privacy',
    //   disabled: false,
    // },
  ]
}
